import { TransactionParameters } from "../view-models/TransactionParameters";
import { useSessionStore } from "../../../state/src/useSessionStore";

const joinNameParts = (...parts: Array<unknown>): string => {
	return parts
		.filter((p) => typeof p === 'string' && (p as string).trim().length > 0)
		.map((p) => (p as string).trim())
		.join(' ');
};

export const buildTransactionParametersFromStore = (validationResponse: any, transactionType: string, sessionId: string, senderFirstName?: string, receiverFirstName?: string): TransactionParameters => {
	const s = (useSessionStore as any).getState?.() || {};
	const referenceNumberSearchResult = (s as any).referenceNumberSearchResult || {};

	const senderFirstNameFromRef = ((): string => {
		if (typeof senderFirstName === 'string' && senderFirstName.trim().length > 0) {
			return senderFirstName.trim();
		}
		const refHasSender = (referenceNumberSearchResult?.SenderFirstName || referenceNumberSearchResult?.SenderLastName);
		if (refHasSender) {
			return joinNameParts(referenceNumberSearchResult?.SenderFirstName, referenceNumberSearchResult?.SenderLastName);
		}
		return joinNameParts(s.senderFirstName, s.senderMiddleName, s.senderLastName, s.senderLastName2);
	})();

	const receiverFirstNameFromRef = ((): string => {
		if (typeof receiverFirstName === 'string' && receiverFirstName.trim().length > 0) {
			return receiverFirstName.trim();
		}
		const refHasReceiver = (referenceNumberSearchResult?.ReceiverFirstName || referenceNumberSearchResult?.ReceiverLastName);
		if (refHasReceiver) {
			return joinNameParts(referenceNumberSearchResult?.ReceiverFirstName , referenceNumberSearchResult?.ReceiverLastName );
		}
		return joinNameParts(s.receiverFirstName, s.receiverMiddleName, s.receiverLastName, s.receiverLastName2);
	})();

	const readyToCommit: boolean = validationResponse?.ReadyForCommit;

	const params = new TransactionParameters();
	params.transactionType = transactionType;
	params.transactionStatus = readyToCommit ? 'Completed' : 'Failed';
	params.senderName = senderFirstNameFromRef ;
	params.receiverName = receiverFirstNameFromRef  ;
		
	params.agentId = s.agentId || undefined;
	params.kioskId = s.kioskId || undefined;
	params.locationName = s.locationName || undefined;
    params.lastScreenViewed = 'finalReview';
	params.amount = (() => {
		const a = s.currentSendAmount;
		if (typeof a === 'string') {
			const n = Number(a.replace(/,/g, ''));
			return isFinite(n) ? n : undefined;
		}
		return typeof a === 'number' ? a : undefined;
	})();
	params.moneyGramTransactionNumber = validationResponse.MgiTransactionSessionID || sessionId;
	// Optional: language setting
	params.language = 'ENG';
	params.startTime = new Date().toISOString();
	params.endTime = new Date().toISOString();
    params.screenDurations = s.recordedScreenDurations || undefined;

	return params;
};
